import React from 'react';

import BasePage from './BasePage';
import ConnectedSearchBaseScreen from '../SearchApp/containers/ConnectedSearchBaseScreen';

export default function SearchPage(props) {
    return (
        <BasePage {...props}>
            <div className="feed-search-page">
                <ConnectedSearchBaseScreen {...props} />
            </div>
        </BasePage>
    );
}
